import React, { useContext } from "react";
import TableWithHeaderBase from "./TableWithHeaderBase";
import classNames from "classnames";
import { MySelectionContext } from "./MySelection";
import { PhosphorPencilButton } from "components/Atoms/PhosphorIconButton";
import { Checkbox } from "components/Atoms/inputs/Checkbox";

export interface CardSections<T> {
  renderTitle: (item: T) => React.ReactNode
  hideTitle: (item: T) => boolean
  renderBody: (item: T) => React.ReactNode
  renderFooter: (item: T) => React.ReactNode
  hideFooter: (item: T) => boolean
}

export interface CardListProps<T> {
  items: T[]
  itemsClassName?: string
  isLoading: boolean
  getId: (item: T) => number
  sections: CardSections<T>
  title?: string
  pagination?: React.ReactNode
  exportButton?: React.ReactNode
  onEdit?: (item: T) => void
  canEdit?: (item: T) => boolean
  onSelect?: (item: T) => void
  layoutButtons?: React.ReactNode
  hideBottomPagination?: boolean
}

const CardList = <T extends any>(props: CardListProps<T>) => {
  const {
    items,
    itemsClassName,
    isLoading,
    getId,
    sections,
    title,
    pagination,
    exportButton,
    onEdit,
    canEdit = () => true,
    onSelect,
    layoutButtons,
    hideBottomPagination
  } = props;
  const mySelection = useContext(MySelectionContext);

  const displayEdit = onEdit != null;
  const canEditItem = (item: T) => canEdit(item) && displayEdit;
  const selectable = props.onSelect != null;


  return <TableWithHeaderBase
    title={title}
    pagination={pagination}
    exportButton={exportButton}
    isLoading={isLoading}
    items={items}
    itemsClassName={itemsClassName}
    selectionEnabled={mySelection.enabled}
    selectionCount={mySelection.selectionCount}
    selectedOnThisPage={mySelection.selectedOnThisPage}
    showingOnlyMySelection={mySelection.showOnlyMySelection}
    toggleAll={mySelection.toggleAll}
    hideTopPaginationOnMobile
    hideBottomPagination={hideBottomPagination}
    layoutButtons={layoutButtons}
  >
    <div className="list-with-gaps card-layout">
      <div className="list-with-gaps-body">
        {items.map(item => <div key={`${getId(item)}`} className={classNames("card-list-item", {
          selected: mySelection.isSelected(item),
          hoverable: selectable
        })}>
          {mySelection.enabled && <div> {<Checkbox
            checked={mySelection.isSelected(item)}
            onChange={() => { mySelection.toggleItem(item); }}
          />}</div>}

          <div className="card-list-item-content" onClick={selectable ? () => { onSelect(item); } : undefined}>
            <div className="card-list-item-top">
              <div className="card-list-item-content">
                {!sections.hideTitle(item) && <>
                  <div className="card-list-item-header">
                    <div className="grow1">
                      {sections.renderTitle(item)}
                    </div>
                    {canEditItem(item) && <PhosphorPencilButton
                      layout="in-square"
                      onClick={() => { onEdit(item); }}
                    />}
                  </div>
                  <div className="divider-line" />
                </>}
                <div className="card-list-item-body">
                  {sections.renderBody(item)}
                </div>
              </div>
            </div>
            {!sections.hideFooter(item) && <><div className="divider-line" />
              <div className="card-list-item-footer">
                {sections.renderFooter(item)}
              </div>
            </>}
          </div>
        </div>)}
      </div>
    </div>
  </TableWithHeaderBase>;
};

export default CardList;